export default __webpack_public_path__ + "media/images/features/ja/map_line_1-da90d24d6d5649e9c082180956df188f.png";